function App() {
 
    return (
      <>
      
      <hr></hr>
   <h1 align='right'> سياسة الخصوصية</h1>
   <hr></hr>
   <body>
    <div dir='rtl'>
    <div > <a href=""></a></div> <br></br>
    <div> خصوصيتك أيها الزائر لها أهمية بالغة بالنسبة لنا &#1548; و سياسة الخصوصية الموجودة في هذه الوثيقة تمثل الخطوط
        العريضة لأنواع المعلومات الشخصية التي يجمعها موقع <a href="https://twitter.com/mojtama_edu"
            target="_blank"><u><b>مجتمع التعليم</b></u></a> وكيفية استخدام هذه المعلومات.<br></br>
        <div > نحن نستعين بشركات إعلان كطرف ثالث لعرض الإعلانات &#1548;
            وعندما تزور موقع <a href="https://twitter.com/mojtama_edu"><u><b>مجتمع التعليم </b></u></a>
            فـ إنه يحق لهذه الشركات أن تستخدم معلومات حول زياراتك لهذا الموقع ( باستثناء الاسم أو العنوان أو عنوان
            البريد الإلكتروني أو رقم الهاتف ) وذلك من أجل تقديم إعلانات حول البضائع والخدمات التي تهمك عن
            طريق&nbsp;<b><a href="https://support.google.com/accounts/answer/61416">ملف تعريف
                    الإرتباط</a></b><b>.<br></br></b> <br></br></div>
                    <div > نحن في&nbsp;<a href="https://twitter.com/mojtama_edu"
                target="_blank"><u><b>مجتمع التعليم</b></u></a>&nbsp;نستخدم إعلانات Google بصفتها
            مور&#1616;&#1617;د&#1611;ا ماليا&#1611; خارجيا&#1611; &#1548; ولذلك تستخدم شركة جوجل&nbsp;<b><a
                    href="https://support.google.com/adsense/answer/7549925">ملف تعريف الإرتباط</a></b>&nbsp;لعرض
            الإعلانات على موقعنا.</div>
        <div > <br></br></div>
        <div > وبذلك ستتمك&#1617;ن Google &#1548; باستخدام ملف تعريف
            الارتباط <b>DART</b> &#1548; من عرض الإعلانات "حسب الاهتمامات" للمستخدمين استناد&#1611;ا إلى زياراتهم
            لموقعنا.</div>
            <div > <br></br></div>
        <div > ويمكن لزوارنا الكرام تعطيل استخدام ملف تعريف الارتباط
            <b>DART</b> بزيارة <a href="https://policies.google.com/technologies/ads" target="_blank">سياسة الخصوصية
                الخاصة بإعلانات Google وشبكة المحتوى</a> .</div>
        <div>
        <div>
            <h4><b>ملفات الدخول:</b></h4>
            <div> شأنها في ذلك شأن معظم خوادم المواقع الأخرى &#1548; ومن هنا فإن موقع&nbsp;<a
                    href="https://twitter.com/mojtama_edu" target="_blank"><u><b>مجتمع التعليم</b></u></a>&nbsp;يستخدم
                نظام ملفات الدخول &#1548; وهذا يشمل بروتوكول الانترنت (عناوين &#1548; نوع المتصفح &#1548; مزود خدمة
                الانترنت "مقدمي خدمات الانترنت" &#1548; &nbsp;التاريخ / الوقت &#1548; وعدد النقرات لتحليل الاتجاهات).
            </div>
        </div>
        <div> <br></br></div>
        <div>
            <div>
                <div> من خلال هذه العملية لا يقصد بذلك جمع كل هذه المعلومات في سبيل التلصص على أمور الزوار الشخصية
                    &#1548; وإنما هي أمور تحليلية لأغراض تحسين جودة الإعلانات من قبل <b>Google</b> &#1548; ويضاف إلى ذلك
                    أن جميع هذه المعلومات المحفوظة من قبلنا سرية تماما&#1548; وتبقى ضمن نطاق التطوير والتحسين الخاص
                    بموقعنا فقط.</div>
            </div>
            <div>
                <h4><b>الكوكيز وإعدادات الشبكة:</b></h4>
            </div>
            <div>
                <div> إن شركة <b>Google</b> تستخدم تقنية الكوكيز لتخزين المعلومات عن إهتمامات الزوار&#1548; إلى جانب سجل
                    خاص للمستخدم تسجل فيه معلومات محددة عن الصفحات التي تم الوصول إليها أو زيارتها&#1548; وبهذه الخطوة
                    فإننا نعرف مدى اهتمامات الزوار وأي المواضيع الأكثر تفضيلا من قبلهم حتى نستطيع بدورنا تطوير محتوانا
                    الخدمي والمعرفي المناسب لهم.</div>
            </div>
            <div> <br></br></div>
            <div>
                <div> نضيف إلى ذلك أن بعض الشركات التي تعلن في&nbsp;<a href="https://twitter.com/mojtama_edu"
                        target="_blank"><u><b>مجتمع التعليم</b></u></a>&nbsp;قد تتطلع على الكوكيز وإعدادات الشبكة الخاصة
                    بموقعنا وبكم &#1548;&nbsp;ومن هذه الشركات مثلا&#1611; شركة <b> Google </b> وبرنامجها الإعلاني <a
                        href="https://www.google.com/adsense/new/u/0/pub-/home" target="_blank"> Google AdSense </a><a
                        href="https://dz-supertools.blogspot.com" target="_blank"  >قوود توينز  Good
                        Twins </a> وهي شركة الإعلانات الأولى في موقعنا.</div>
            </div>
            <div> <br></br></div>
            <div>
                <div> وبالطبع فمثل هذه الشركات المعلنة والتي تعتبر الطرف الثالث في سياسة الخصوصية فهي تتابع مثل هذه
                    البيانات والإحصائيات عبر بروتوكولات الانترنت لأغراض تحسين جودة إعلاناتها وقياس مدى فعاليتها.</div>
            </div>
            <div> <br></br></div>
            <div>
                <div> كما أن هذه الشركات بموجب الاتفاقيات المبرمة معنا يحق لها استخدام وسائل تقنية مثل ( الكوكيز &#1548;
                    و إعدادات الشبكة &#1548; و أكواد برمجية خاصة "جافا سكربت" ) لنفس الأغراض المذكورة أعلاه والتي تتلخص
                    في تطوير المحتوى الإعلاني لهذه الشركات وقياس مدى فاعلية هذه الإعلانات &#1548; من دون أي أهداف أخرى
                    قد تضر بشكل أو بآخر على زوار موقعنا.</div>
            </div>
            <div> <br></br></div>
            <div>
                <div> وبالطبع فإن موقع&nbsp;<a href="https://twitter.com/mojtama_edu" target="_blank"><u><b>مجتمع
                                التعليم</b></u></a>&nbsp;لا يستطيع الوصول أو السيطرة على هذه الملفات&#1548; وحتى بعد
                    سماحك وتفعيلك لأخذها من جهازك (الكوكيز) &#1548; كما أننا غير مسؤولين بأي شكل من الأشكال عن الاستخدام
                    غير الشرعي لها إن حصل ذلك .</div>
            </div>
            <div> <br></br></div>
            <div>
                <div> عليك مراجعة سياسة الخصوصية الخاصة بالطرف الثالث في هذه الوثيقة &nbsp;( الشركات المعلنة مثل&nbsp;<a
                        href="https://www.google.com/adsense/new/u/0/pub-6474783717476116/home" target="_blank">Google
                        AdSense</a>&nbsp;) أو خوادم الشبكات&nbsp;الإعلانية لمزيد من المعلومات عن ممارساتها وأنشطتها
                    المختلفة .</div>
            </div>
            <div> <br></br></div>
            <div> لمراجعة سياسة الخصوصية للبرنامج الإعلاني&nbsp;<a
                    href="https://www.google.com/adsense/new/u/0/pub-6474783717476116/home" target="_blank">Google
                    AdSense</a>&nbsp;والتابع لشركة <b>Google </b>يرجى النقر <a
                    href="/p/blog-page_10.html?link=https%3A%2F%2Fwww.google.com%2Fpolicies%2Ftechnologies%2Fads%2F"
                    target="_blank">هنا</a></div>
            <div> <br></br></div>
            <div>
                <div> ي&#1615;مكن جمع البيانات لتجديد النشاط التسويقي على الشبكة الإعلانية وشبكة البحث عبر &nbsp;سياسة
                    الإعلانات التي تستهدف الاهتمامات والمواقع الخاصة بالزوار &#1548; ويمكن تعطيل هذه الخاصية من <a
                        href="/p/blog-page_10.html?link=https%3A%2F%2Ftools.google.com%2Fdlpage%2Fgaoptout%2F%3Fhl%3Dar"
                        target="_blank">هنا</a>.</div>
            </div>
            <div> <br></br> </div>
            <div>
                <div>وأخيرا .. نحن ملزمون ضمن بنود هذه الاتفاقية بان نبين لك كيفية تعطيل خاصية الكوكيز &#1548; حيث يمكنك
                    فعل ذلك من خلال خيارات المتصفح الخاص بك&#1548; أو من خلال متابعة &nbsp;<a
                        href="https://policies.google.com/technologies/ads" target="_blank">سياسة الخصوصية الخاصة
                        بإعلانات Google وشبكة المحتوى</a> .</div>
            </div>
            <div> <br></br></div>
            <div>
                <div>إذا كنت بحاجة إلى مزيد من المعلومات أو لديك أية أسئله عن سياسة الخصوصية &#1548; لا تتردد في الاتصال
                    بنا عن طريق نموذج الإتصال &#1548; بالدخول إلى تبويب <span><b><a
                                href="https://twitter.com/mojtama_edu">اتصل بنا</a></b></span>.</div>
            </div>
            <div>
                <div>بنود هذه السياسة قابلة للتطوير والتغيير في محتواها في أي وقت نراه ضروريا&#1611; .</div>
            </div>
        
            </div>
        </div>
    </div>

    </div>
   </body>
      <body>
      <h1>PRIVACY NOTICE</h1>
      <hr></hr>
      <p>
        This is privacy notice for Community (" Company," "we," "us," or "our" )
        describes how and why we might collect, store, use, and/or share ("process") 
        your information when you use our services ("Services"), such as when you:
      </p>
    <ul>
    <li>Download and use our mobile application (Community) , or any other application of ours that links to this privacy notice</li>
    <li>Engage with us in other related ways, including any sales, marketing, or events</li>
  </ul> 
  </body>
  <body>
  <p> Questions or concerns? 
    Reading this privacy notice will help you understand your privacy rights and choices. 
    If you do not agree with our policies and practices, please do not use our Services.
    If you still have any questions or concerns, please contact us at shakeritsolutions@gmail.com.</p>
    <hr></hr>
    <h2>Information Collection and Use</h2>
    <p>We collect several different types of information for various purposes to provide and improve our Service to you</p>
    </body>
    <hr></hr>
  
  
    <body>
    <h2>WHAT INFORMATION DO WE COLLECT?</h2>
    <hr></hr>
    <h3>1. Personal information you disclose to us</h3>
    <h5>In Short: We collect personal information that you provide to us.</h5>
    <p>We collect personal information that you voluntarily provide to us when you register on the Services, express an interest in obtaining information about us or our products and Services,
       when you participate in activities on the Services, or otherwise when you contact us.</p>
    <p>Personal Information Provided by You. The personal information that we collect depends on the context of your interactions with us and the Services, the choices you make, 
        and the products and features you use.The personal information we collect may include the following:</p>
    <ul>
    <li>names</li>
    <li>email addresses</li>
    <li>contact preferences</li>
    <li>contact or authentication data</li>
    <li>usernames</li>
    <li>phone numbers</li>
  </ul> 
  <h3>Sensitive Information.</h3>
    <h4>When necessary, with your consent or as otherwise permitted by applicable law, 
      we process the following categories of sensitive information:</h4>
    <p>If you use our application(s), we also may collect the following information if you choose to provide us with access or permission:</p>
    <ul>
    <li>Mobile Device Access. We may request access or permission to certain features from your mobile device, including your mobile device's contacts, and other features. If you wish to change our access or permissions, you may do so in your device's settings.</li>
    <li>Mobile Device Data. We automatically collect device information (such as your mobile device ID, model, and manufacturer), operating system, version information and system configuration information, device and application identification numbers, browser type and version, hardware model Internet service provider and/or mobile carrier, and Internet Protocol (IP) address (or proxy server). If you are using our application(s), we may also collect information about 
      the phone network associated with your mobile device, your mobile device’s operating system or platform, the type of mobile device you use, your mobile device’s unique device ID, and information about the features of our application(s) you accessed.</li>
    <li>Push Notifications. We may request to send you push notifications regarding your account or certain features of the application(s). If you wish to opt out from receiving these types of communications, you may turn them off in your device's settings.</li>
  <p>This information is primarily needed to maintain the security and operation of our application(s), for troubleshooting, and for our internal analytics and reporting purposes.<br></br>
  All personal information that you provide to us must be true, complete, and accurate, and you must notify us of any changes to such personal information.</p>
  </ul> 
  </body>
  <hr></hr>
  
  <body>
    <h3>2. HOW DO WE PROCESS YOUR INFORMATION?</h3>
    <h5>In Short: We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process
       your information for other purposes with your consent.</h5>
    <p>We process your personal information for a variety of reasons, depending on how you interact with our Services, including:</p>
    <ul>
      <li>
      <b>To facilitate account creation and authentication and otherwise manage user accounts.</b>We may process your information so you can create and log in to your account, as well as keep your account in working order.
      </li><br></br>
      <li><b>To deliver and facilitate delivery of services to the user. </b>We may process your information to provide you with the requested service.</li>
    </ul>
  </body>
  <hr></hr>
  
  <body>
  <h3>3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</h3>
    <h5>In Short: We DO NOT share information  with the following third parties.</h5>
  </body>
  <hr></hr>
  
  <body>
  <h3>4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</h3>
    <h5>In Short: We may use cookies and other tracking technologies to collect and store your information.</h5>
    <p>We may use cookies and similar tracking technologies to access or store information. Specific information about how we use such technologies and how you can refuse certain cookies is set out in our Cookie Notice.</p>
  </body>
  <hr></hr>
  
  <body>
  <h3>5. HOW LONG DO WE KEEP YOUR INFORMATION?</h3>
    <h5>In Short: We keep your information for as long as necessary to fulfill the purposes outlined in this privacy notice unless otherwise required by law.</h5>
    <p>We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy notice, unless a longer retention period is required or permitted by law (such as tax, accounting, or other legal requirements). No purpose in this notice will require us keeping 
      your personal information for longer than the period of time in which users have an account with us.</p>
    <p>When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize such information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal
         information and isolate it from any further processing until deletion is possible.</p>
  </body>
  <hr></hr>
  
  <body>
  <h3>6. HOW DO WE KEEP YOUR INFORMATION SAFE?</h3>
    <h5>In Short: We aim to protect your personal information through a system of organizational and technical security measures.</h5>
    <p>We have implemented appropriate and reasonable technical and organizational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. Although we will do our best to protect your personal information, transmission of personal information to and from our Services is at your own risk. 
      You should only access the Services within a secure environment.</p>
  </body>
  <hr></hr>
  
  <body>
  <h3>7. WHAT ARE YOUR PRIVACY RIGHTS?</h3>
    <h5>In Short:  You may review, change, or terminate your account at any time.</h5>
    <h3>Account Information</h3>
    <p>If you would at any time like to review or change the information in your account or terminate your account, you can:</p>
    <ul>
    
      <li>
      Log in to your account settings and update your user account.
      </li><br></br>
      <li>Contact us using the contact information provided.</li>
    </ul>
    <p>Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases. However, we may retain some information in our files to prevent fraud, troubleshoot problems, assist with any investigations, 
      enforce our legal terms and/or comply with applicable legal requirements.</p>
  <p><u><b>Cookies and similar technologies:</b></u> Most Web browsers are set to accept cookies by default. If you prefer, you can usually choose to set your browser to remove cookies and to reject cookies. If you choose to remove cookies or reject cookies, this could affect certain features or services of our Services. </p>
  <p>If you have questions or comments about your privacy rights, you may email us at <b>shakeritsolutions@gmail.com</b></p>
  </body>
  <hr></hr>
  
  <body>
  <h3>8. CONTROLS FOR DO-NOT-TRACK FEATURES</h3>
    
    <p>Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track ("DNT") feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. At this stage no uniform technology standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice 
      in a revised version of this privacy notice.</p>
  </body>
  <hr></hr>
  
  <body>
  <h3>9. DO WE MAKE UPDATES TO THIS NOTICE?</h3>
    <h5>In Short: Yes, we will update this notice as necessary to stay compliant with relevant laws.</h5>
    <p>We may update this privacy notice from time to time. The updated version will be indicated by an updated "Revised" date and the updated version will be effective as soon as it is accessible. If we make material changes to this privacy notice,
       we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this privacy notice frequently to be informed of how we are protecting your information.</p>
  </body>
  <hr></hr>
  
  <body>
  <h3>10. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h3>
    
    <p>If you have questions or comments about this notice, you may email us at shakeritsolutions@gmail.com or by post to:</p>
   <p><b>Community</b></p>
   <p><b>Saudi Arabia</b></p>
    </body>
  <hr></hr>
  
  
  
    </>
    
  
  
  )}
  
  export default App;
  